import { EntityMetadata } from '@ngrx/data';

export interface AppointmentListQueryFilter {
    personIds?: Array<number>;
    totalLoaded: number;
    lastUpdated: number;
}

/**
 * Meta data for the entity to be included in the EntityMetadataMap registered in the EntityModule.
 */
export const appointmentListEntityMetadata: EntityMetadata<any> = {
    entityName: 'AppointmentList',
    selectId: personId, // .id is used if doing optimistic update
    additionalCollectionState: {
        refreshing: false,
        queryFilter: {
            personIds: []
        }
    }
    // https://stackoverflow.com/questions/62828590/how-to-extend-custom-entity-collection-reducers-in-ngrx-data

    // filterFn: nameFilter,
    // sortComparer: sortByName
    // entityDispatcherOptions: { optimisticAdd: true, optimisticUpdate: true }
};

// tslint:disable-next-line:only-arrow-functions typedef
export function personId<T extends { id: any }>(personid: number) {
    return  personid === undefined ? undefined : personid;  // .id is used if doing optimistic update
}
